export const DEFAULT_SELLER_COUNTRY = "France";

/**
 * Convention historique de la colonne `address` : segments séparés par des
 * points-virgules, dans l'ordre rue;ville;code postal.
 *
 * Ce format est lu ailleurs en accédant aux index 0/1/2 — demande de compte
 * Stripe côté back (user.ts) et côté studio, fiche client admin. L'ordre et
 * le séparateur ne sont donc PAS libres : les virgules casseraient ces flux.
 *
 * Le pays est ajouté en 4ᵉ segment : ignoré par les lecteurs existants qui
 * s'arrêtent à l'index 2, et affiché sur les factures.
 */
export const SELLER_ADDRESS_SEPARATOR = ";";

export const formatSellerAddress = ({ street, zipCode, city, country }) =>
  [street, city, zipCode, country]
    .map((part) => (part || "").trim())
    .join(SELLER_ADDRESS_SEPARATOR);

/**
 * Ré-éclatement de la chaîne renvoyée par l'API.
 *
 * Une adresse enregistrée avant l'ajout du pays n'a que 3 segments : le pays
 * retombe alors sur la valeur par défaut.
 */
export const parseSellerAddress = (address) => {
  const empty = {
    street: "",
    zipCode: "",
    city: "",
    country: DEFAULT_SELLER_COUNTRY,
  };

  if (!address || typeof address !== "string") return empty;

  const parts = address
    .split(SELLER_ADDRESS_SEPARATOR)
    .map((part) => part.trim());

  return {
    street: parts[0] || "",
    city: parts[1] || "",
    zipCode: parts[2] || "",
    country: parts[3] || DEFAULT_SELLER_COUNTRY,
  };
};
